// window.scrollMaxY not supported by WebKit based browsers nor IE
// http://stackoverflow.com/questions/1091048/alternatives-to-window-scrollmaxy
// https://developer.mozilla.org/en-US/docs/Web/API/window.scrollMaxY
if(!("scrollMaxY" in window)){
	Object.defineProperty(window, "scrollMaxY", {
		get: function scrollMaxY(){
			var htmlElement = window.document.documentElement;
			return htmlElement.scrollHeight - htmlElement.clientHeight;
		}
	})
}